


















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IPagination } from "@/model/component.model";

@Component({})
export default class Pagination extends Vue {
  @Prop({})
  pagination: IPagination;
  pages = "";

  get pageSizes() {
    if (this.pagination.perPageOptions.length === 1) {
      this.pages = " " + String(this.pagination.perPageOptions[0]);
      return null;
    } else {
      return this.pagination.perPageOptions;
    }
  }

  handleSizeChange(val: number) {
    this.$emit(
      "onPaginationChanged",
      Object.assign({}, this.pagination, { perPage: val })
    );
  }

  handleCurrentChange(val: number) {
    this.$emit(
      "onPaginationChanged",
      Object.assign({}, this.pagination, { currentPage: val })
    );
  }
}
